// html type=email validation from http://emailregex.com/
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

export const NANOID_REGEX = /\/r\/[A-Za-z0-9_-]{11}/;
